import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestCacheStatus } from 'api/types';

export interface AsyncState<T> {
  content: T;
  loading: boolean;
  error?: unknown;
  requestCache?: RequestCacheStatus;
}
// Реализация взамен deprecated genericReducers
export function createAsyncSlice<TData, TRequest = void>(name: string, initialContent: TData) {
  const initialState: AsyncState<TData> = {
    content: initialContent,
    loading: false,
    requestCache: 'notCached',
  };

  return createSlice({
    name,

    initialState,

    reducers: {
      request(state, _action: PayloadAction<TRequest>) {
        state.loading = true;
        state.error = undefined;
        state.requestCache = 'requested';
      },

      success(state, action: PayloadAction<TData>) {
        return {
          ...state,
          content: action.payload,
          loading: false,
          error: undefined,
          requestCache: 'cached',
        };
      },

      failure(state, action: PayloadAction<unknown>) {
        state.loading = false;
        state.error = action.payload;
        state.requestCache = 'failed';
      },

      invalidate(state) {
        state.requestCache = 'invalidated';
      },
    },
  });
}
